import { render, staticRenderFns } from "./TgLiveHeader.vue?vue&type=template&id=e1e55a4a&"
import script from "./TgLiveHeader.vue?vue&type=script&lang=js&"
export * from "./TgLiveHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports